import { makeStyles } from '@material-ui/core/styles'
import { colors } from 'src/components/app-ui'

const useStyles = makeStyles(theme => ({
  root: {
    maxWidth: 820,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
  },
  cardTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '15px',
    fontWeight: 600,
    color: colors.navy,
  },
  cardDesc: {
    marginTop: 4,
    fontSize: '13px',
    lineHeight: 1.5,
    color: colors.muted,
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.navy,
  },

  // Logo
  uploads: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '16px',
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  uploadLabel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.navy,
  },
  upload: {
    position: 'relative',
    height: 120,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    border: '2px dashed rgba(1,95,251,.5)',
    borderRadius: '12px',
    background: 'rgba(1,95,251,.06)',
    cursor: 'pointer',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.primary,
    overflow: 'hidden',
  },
  uploadFilled: {
    border: `1px solid ${colors.border}`,
    background: '#FFFFFF',
  },
  uploadHint: {
    fontSize: '12px',
    fontWeight: 400,
    color: colors.muted,
  },
  preview: {
    maxWidth: '80%',
    maxHeight: 72,
    objectFit: 'contain',
  },
  linkButton: {
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '12px',
    fontWeight: 500,
    color: colors.primary,
    '&:disabled': {
      cursor: 'default',
      color: colors.subtle,
    },
  },

  // Colors
  swatches: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '10px',
  },
  swatch: {
    width: 32,
    height: 32,
    padding: 0,
    border: 0,
    borderRadius: '50%',
    cursor: 'pointer',
  },
  picker: {
    width: 32,
    height: 32,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: `1px dashed ${colors.subtle}`,
    borderRadius: '50%',
    background: '#FFFFFF',
    cursor: 'pointer',
    color: colors.muted,
  },
  hex: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    marginLeft: 8,
    padding: '0 10px',
    border: `1px solid ${colors.borderSoft}`,
    borderRadius: '8px',
    '&:focus-within': {
      borderColor: colors.primary,
    },
  },
  hexDot: {
    width: 16,
    height: 16,
    flex: 'none',
    borderRadius: '4px',
  },
  hexInput: {
    width: 84,
    padding: '7px 0',
    border: 0,
    outline: 'none',
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '13px',
    color: colors.navy,
    textTransform: 'uppercase',
  },
  // Custom code
  codeHead: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '16px',
  },
  plus: {
    padding: '2px 8px',
    borderRadius: '999px',
    background: colors.primarySoft,
    fontSize: '11px',
    fontWeight: 600,
    color: colors.primary,
  },
  editor: {
    border: `1px solid ${colors.border}`,
    borderRadius: '10px',
    overflow: 'hidden',
  },
  editorBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '12px',
    padding: '8px 8px 8px 12px',
    borderBottom: `1px solid ${colors.border}`,
    background: '#FFFFFF',
  },
  editorTab: {
    padding: '6px 12px',
    border: 0,
    borderRadius: '6px',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
  },
  editorHint: {
    paddingRight: 6,
    fontSize: '12px',
    color: colors.subtle,
  },
  textarea: {
    display: 'block',
    width: '100%',
    minHeight: 220,
    padding: '16px',
    border: 0,
    outline: 'none',
    resize: 'vertical',
    background: '#0B1B2B',
    color: '#E6EDF3',
    fontFamily: 'ui-monospace, Menlo, monospace',
    fontSize: '13px',
    lineHeight: 1.6,
    '&:disabled': {
      opacity: 0.6,
      cursor: 'not-allowed',
    },
  },
  codeFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '12px',
    fontSize: '12px',
    color: colors.subtle,
  },
  actions: {
    display: 'flex',
    gap: '8px',
  },
}))

export default useStyles
